import { render, staticRenderFns } from "./SuperTable.vue?vue&type=template&id=0a039205&scoped=true"
import script from "./SuperTable.vue?vue&type=script&lang=js"
export * from "./SuperTable.vue?vue&type=script&lang=js"
import style0 from "./SuperTable.vue?vue&type=style&index=0&id=0a039205&prod&lang=scss&scoped=true"
import style1 from "./SuperTable.vue?vue&type=style&index=1&id=0a039205&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a039205",
  null
  
)

export default component.exports